import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppEnvironment } from '@ca/environment/app-environment.enum';
import { environment } from '@ca/environment/environment';
import * as Sentry from '@sentry/angular';
import '@zeiss/zui';
import '@zeiss/zui-icons';
import { AppModule } from './app/app.module';
import { loadExternalScripts } from './utils/scripts/scripts';

if (environment.type === AppEnvironment.Production) {
    enableProdMode();
}

loadExternalScripts();

if (environment.type === AppEnvironment.Production) {
    Sentry.init({
        dsn: 'https://e4e8e7c20043424a85719144a93e5c2c@o272433.ingest.sentry.io/1485475',
        integrations: [
            // Registers and configures the Tracing integration,
            // which automatically instruments your application to monitor its
            // performance, including custom Angular routing instrumentation
            Sentry.browserTracingIntegration(),
        ],
        tracePropagationTargets: ['localhost:4200/api', 'develop.dis-apeer.com/api', 'www.apeer.com/api'],

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 0.1,
    });
}

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch(err => console.error(err));
